<template><div><h1>VUX V2.1.0Rc.51 released</h1>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul></ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.51 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.51-74.vue?ff940be4